import type { RouteSegment } from '@/api/main/types.gen'
import { isEmpty } from 'lodash-es'

export function routeSegmentsEqual(a: RouteSegment[], b: RouteSegment[]): boolean {
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    const left = a[i]!
    const right = b[i]!
    if (
      left.street_segment_id !== right.street_segment_id ||
      left.entrance_node_id !== right.entrance_node_id ||
      left.exit_node_id !== right.exit_node_id
    ) {
      return false
    }
  }
  return true
}

/** Index into `tail` at which `nodeId` reconnects, or null if no reconnect exists. */
export function findTailReconnectIndex(tail: RouteSegment[], nodeId: string | undefined): number | null {
  if (!nodeId || isEmpty(tail)) return null
  const entranceIdx = tail.findIndex(s => s.entrance_node_id === nodeId)
  if (entranceIdx >= 0) return entranceIdx
  const exitIdx = tail.findIndex(s => s.exit_node_id === nodeId)
  if (exitIdx >= 0) return exitIdx + 1
  return null
}
